import { Vector3 } from "@babylonjs/core/Maths/math.vector";

export class TrackingShot {

  ease?: string;
  duration?: number;
  preventSpin?: boolean;

  constructor(
    readonly alpha: number,
    readonly beta: number,
    readonly radius: number,
    readonly target: Vector3,
    ease?: string,
    duration?: number,
    preventSpin?: boolean
  ) {
    this.ease = ease ? ease : "none";
    this.duration = duration ? duration : 1;
    this.preventSpin = preventSpin ? preventSpin : true;
  }

}